import React, { useEffect, useState, Fragment } from 'react'
import { StandardPage } from '../../components/_EOS/StandardPage/StandardPage'
import { ProductSearch } from './ProductSearch'
import { Filter } from '../../components/_WMS/FilterComponent'
import { defaultFilters } from './config'
import { getProductList } from './api'
import { Product, ProductoGrid } from './entities/Product'
import { ApiResponse } from '../../typings/ApiResponse'
import { useApi } from '../../hooks/useApi'
import { Status } from '../../hooks/useFetchState'
import { usePagination } from '../../hooks/usePagination'
import { GenericTable } from '../../components/_EOS/Table/GenericTable'
import { GenericOrderBy } from '../../components/_EOS/Table/types'
import { generateTableHeadersProduct } from '.'
import { useProductOrigins } from '../../hooks'
import { Modal } from '../../components/_EOS/Modal'
import { SnackBar } from '../../components/SnackBar/Snackbar'
import { useSnackbar } from '../../hooks/useSnackbar'
import { useModal } from '../../hooks/useModal'
import { IconButton, Tooltip } from '@mui/material'
import { AddCircle, ListAlt } from '@mui/icons-material'
import { ViewProducto } from './ViewProducto/ViewProducto'
import { CreateDun } from './Dun/CreateDun'

interface ProductPageProps {}

export const NewProductPage: React.FC<ProductPageProps> = () => {
  type CustomActionsProps = {
    id: number
    row: Product
  }

  const [selectedFilters, setSelectedFilters] =
    React.useState<Filter[]>(defaultFilters)
  const { state, callApi } = useApi<ApiResponse<Product>>()
  const [selectedElement, setSelectedElement] = React.useState<string[]>([])
  const pagination = usePagination(10)
  const { isActive, isSuccess, message, openSnackBar } = useSnackbar()

  const requestProduct = (
    filters?: Filter[],
    page?: number,
    pageSize?: number
  ) => {
    callApi(getProductList(filters, page, pageSize)).catch((error) => {
      console.log(error)
    })
  }

  const handleRefreshGrid = () => {
    requestProduct(selectedFilters, pagination.page, pagination.pageSize)
  }

  const handlePaginationChange = (page: number, pageSize: number) => {
    // If the pageSize is different, we should set page 0
    const auxPage = pagination.pageSize !== pageSize ? 0 : page

    setSelectedElement([])

    requestProduct(selectedFilters, auxPage, pageSize)

    pagination.setPagination(auxPage, pageSize)
  }

  const [orderBy] = useState<GenericOrderBy<Product>>({
    field: '',
    direction: 'desc'
  })

  useEffect(() => {
    pagination.setPagination(0, pagination.pageSize)

    requestProduct(selectedFilters, 0, pagination.pageSize)
  }, [orderBy, selectedFilters])

  const {
    getProductOrigins,
    productOriginsState: { productOrigins }
  } = useProductOrigins()

  useEffect(() => {
    getProductOrigins()
  }, [])

  const tableHeadersProduct = generateTableHeadersProduct(productOrigins)

  const productDunModal = useModal<{
    name: string
    sku: string
  }>('')

  const productViewModal = useModal<{
    item: Product
  }>('')

  const MyCustomActions: React.FC<CustomActionsProps> = ({ row }) => {
    return (
      <Fragment>
        <Tooltip title='Agregar DUN' aria-label='edit'>
          <IconButton
            aria-label='seeBinacle'
            onClick={() =>
              productDunModal.openModal(
                'lg',
                { name: row.name, sku: row.sku },
                'Gestionar DUN'
              )
            }
            style={{ verticalAlign: 'bottom' }}
          >
            <AddCircle />
          </IconButton>
        </Tooltip>
        <Tooltip title='Ver Detalle Producto' aria-label='edit'>
          <IconButton
            aria-label='seeBinacle'
            onClick={() => productViewModal.openModal('md', { item: row })}
            style={{ verticalAlign: 'bottom' }}
          >
            <ListAlt />
          </IconButton>
        </Tooltip>
      </Fragment>
    )
  }

  return (
    <Fragment>
      <StandardPage pageTitle='Administrador De Productos'>
        <ProductSearch
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
          onSearchClick={requestProduct}
        />

        <GenericTable<Product>
          headersConfig={tableHeadersProduct}
          IDKey={'id'}
          data={state.data?.items}
          pagination={{
            totalItem: state.data?.totalItems || 0,
            page: pagination.page,
            pageSize: pagination.pageSize
          }}
          onPaginationChange={handlePaginationChange}
          isLoading={state.status === Status.Loading}
          showCheckboxes={false}
          checkedElements={selectedElement}
          orderField={orderBy}
          customActionComponent={MyCustomActions}
        />
      </StandardPage>

      <Modal
        open={productDunModal.isOpen}
        onClose={productDunModal.closeModal}
        title={productDunModal.title}
        maxWidth={productDunModal.size}
      >
        <CreateDun
          nombreProducto={productDunModal.extendedProps?.name || ''}
          sku={productDunModal.extendedProps?.sku || ''}
          handleSnackbar={openSnackBar}
          handleCloseModal={productDunModal.closeModal}
        />
      </Modal>

      <Modal
        open={productViewModal.isOpen}
        onClose={productViewModal.closeModal}
      >
        <ViewProducto
          elemento={productViewModal.extendedProps?.item as ProductoGrid}
          refreshGrid={() => handleRefreshGrid()}
        />
      </Modal>

      <SnackBar
        open={isActive}
        status={isSuccess ? 'success' : 'error'}
        message={message}
      />
    </Fragment>
  )
}
